import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AccountState } from '@state/account/state';
import { TaskRelatedToModule } from '@tasks/tasks.types';
import { JupiterState } from 'app/modules/jupiter/@store/state';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';
import { plural } from 'pluralize';

@Injectable({
  providedIn: 'root',
})
export class TasksBaseUrlService {
  constructor(private store: Store) {}

  /**
   * @deprecated Use shallow routing (e.g. `'tasks'`) for task endpoints.
   * This method is retained for task_list endpoints that still require nested routes.
   * Will be removed when task_list routes are also migrated to shallow routes.
   */
  getTasksUrl(relatedToType: string, relatedToTypeId: number): string {
    if (relatedToType === TaskRelatedToModule.AggregatedTasks) {
      relatedToType = 'Account';
    }

    if (relatedToType === TaskRelatedToModule.TaskListTemplate) {
      relatedToType = 'Account';
      relatedToTypeId = +this.store.selectSnapshot(AccountState.getAccount)?.id;
    }

    if (relatedToType === TaskRelatedToModule.CustomObjectValue) {
      const accountId = +this.store.selectSnapshot(AccountState.getAccount)?.id;
      const selectedCo =
        this.store.selectSnapshot(ObjectsManagerState.getById) ??
        this.store.selectSnapshot(JupiterState.getRelatedToObject);
      return `accounts/${accountId}/custom_objects/${selectedCo?.id}/values/${relatedToTypeId}`;
    }

    const pluralType = plural(relatedToType).toLowerCase();
    return `${pluralType}/${relatedToTypeId}`;
  }
}
